/** @format */
import { ChangeDetectionStrategy, Component, Inject, input } from '@angular/core';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'pdp-feedback',
	templateUrl: './feedback.component.html',
	styleUrl: './feedback.component.scss',
	imports: [HmfButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackComponent {
	readonly formId = input<string>();

	constructor(@Inject(WINDOW) protected window: Window) {}
	public loadSurvey() {
		if (typeof this.window.KAMPYLE_ONSITE_SDK !== 'undefined') {
			this.window.KAMPYLE_ONSITE_SDK.showForm(this.formId());
		}
	}
}
